import { Box } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import { HoverExpandableContainer, StatusChip } from '../../../common/components';

const HOVER_OFFSET = 8;
const MAX_CONTENT_HEIGHT = 220;

const HoverExpandableAmmounts = ({ items = [] }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [anchorRect, setAnchorRect] = useState(null);
  const [placement, setPlacement] = useState('bottom');
  const containerRef = useRef(null);

  const updateOverlayPosition = () => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const availableBottom = window.innerHeight - rect.bottom;
    const newPlacement = availableBottom < MAX_CONTENT_HEIGHT ? 'top' : 'bottom';
    setPlacement(newPlacement);
    setAnchorRect(rect);
  };

  useEffect(() => {
    if (!isHovered) return;

    updateOverlayPosition();
    window.addEventListener('scroll', updateOverlayPosition, true);
    window.addEventListener('resize', updateOverlayPosition);

    return () => {
      window.removeEventListener('scroll', updateOverlayPosition, true);
      window.removeEventListener('resize', updateOverlayPosition);
    };
  }, [isHovered]);

  if (!items || items.length === 0) return null;

  return (
    <Box
      ref={containerRef}
      sx={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => {
        setIsHovered(true);
        updateOverlayPosition();
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        setAnchorRect(null);
      }}
    >
      <StatusChip label={items[0]} size="medium"  />

      {items.length > 1 && isHovered && anchorRect && (
        <HoverExpandableContainer
          anchorRect={anchorRect}
          placement={placement}
          offset={HOVER_OFFSET}
        >
          {items.map((item, index) => (
            <StatusChip
              key={index}
              label={item}
              size="medium"
              sx={{
                display: 'block',
                paddingTop: 1,
                marginBottom: index < items.length - 1 ? '8px' : '0',
              }}
            />
          ))}
        </HoverExpandableContainer>
      )}
    </Box>
  );
};

export default HoverExpandableAmmounts;
